export default __webpack_public_path__ + "static/media/summary-cg-img.3627f270.png";